import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/54350176/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/contentswitcher--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-content-switcher--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvcontentswitcher--default',
      Vanilla: 'https://vanilla.carbondesignsystem.com/?nav=content-switcher'
    }} mdxType="ComponentDemo">{`
<ContentSwitcher onChange={console.log}>
  <Switch name={'first'} text='First section' />
  <Switch name={'second'} text='Second section' />
  <Switch name={'third'} text='Third section' />
</ContentSwitcher>
`}</ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      